function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 3.57c4.6 0 8.4 3.769 8.4 8.43s-3.8 8.43-8.4 8.43c-4.6 0-8.4-3.769-8.4-8.43S7.4 3.57 12 3.57zM12 0C5.4 0 0 5.355 0 12s5.4 12 12 12 12-5.355 12-12S18.6 0 12 0z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;